var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"fill-height"},[_c('v-title',{attrs:{"title":"Статьи о кредитах и недвижимости"}}),_c('iframe',{staticClass:"fill-height fill-width b-0",attrs:{"src":"https://fin-success.biz/iframe.html"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }